/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import {Component, ViewEncapsulation} from '@angular/core';
import {AuthService} from "../../../core/auth.service";
import {PaymentService} from "../../../payment/payment.service";
import {StateService} from "../../../core/state.service";
import {Subject} from "rxjs/Rx";

@Component({
    selector: 'history',
    template: `
<div>
    <div class="standalone_title">Payment History</div>
    <div *ngIf="pmt.customer && pmt.customer.last_3_invoices.data" class="flex justify-between items-center ">
        <table cellspacing="5">
            <tr class="underlined">
                <th *ngIf="mode != 'mobile'" align="right">Date</th>
                <th *ngIf="mode != 'mobile'">Description</th>
                <th align="center">Period</th>
                <th *ngIf="mode != 'mobile'">Payment Method</th>
                <th *ngIf="mode != 'mobile'" align="right">Subtotal</th>
                <th align="right">Total</th>
                <th *ngIf="mode != 'mobile'"></th>
            </tr>
            <tr *ngFor="let invoice of pmt.customer.last_3_invoices.data ">
                <td *ngIf="mode != 'mobile'" align="right">{{invoice.date * 1000 | date}}</td>
                <td *ngIf="mode != 'mobile'">{{invoice.customer}}</td>
                <td align="center">{{invoice.period_start * 1000 | date}} - {{invoice.period_end * 1000 | date}}</td>
                <td *ngIf="mode != 'mobile'">payment method</td>
                <td *ngIf="mode != 'mobile'" align="right">{{invoice.subtotal / 100 | currency:invoice.currency.toUpperCase():''}}</td>
                <td align="right">{{invoice.total / 100 | currency:invoice.currency.toUpperCase():''}}</td>
                <td *ngIf="mode != 'mobile'"><a [href]="invoice.invoice_pdf" target="_blank" ><mat-icon>picture_as_pdf</mat-icon></a></td>
            </tr>
        </table>
    </div>
</div>

    `,
    styles: [`
        table { width:100%; }
        .smaller_text { font-size: 14px; line-height: 24px; }
        th { color: #999999; font-weight: normal; font-size: 14px; }
        tr.underlined { border-bottom: 1px solid #999999; }
        td { font-size: 14px; }
    `],
    encapsulation: ViewEncapsulation.None
})
export class PaymentHistoryComponent {

    mode = '';
    private $destroy: Subject<boolean> = new Subject();

    constructor(private pmt: PaymentService, private auth: AuthService, public state:StateService) {

        this.state.screen.takeUntil(this.$destroy).subscribe(mode => {
            this.mode = mode
        });
    }

    ngOnInit() {
    }

    ngOnDestroy(){
        this.$destroy.next();this.$destroy.complete();
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/account/components/history.ts